import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import BoxButtonFooter from '../common/button/boxButtonFooter';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Select from '../common/form/select';

import { setModoTela } from './usuarioTipoActions';

class UsuarioTipoForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<Row>
						<Field
							name='nome'
							component={LabelAndInput}
							label='Nome *'
							placeholder='Informe o Nome'
							cols='12 10 6 4'
							readOnly={readOnly} />
					</Row>

					<Row>
						<Grid>
							<label>Permissões</label>
						</Grid>
					</Row>

					<Row>
						<Field
							name='permissao_usuario'
							component={LabelAndCheckbox}
							label='Usuários'
							cols='6 3 2 2'
							readOnly={readOnly} />

						<Field
							name='permissao_cadastro'
							component={LabelAndCheckbox}
							label='Cadastros'
							cols='6 3 2 2'
							readOnly={readOnly} />

						<Field
							name='permissao_manutencao'
							component={LabelAndCheckbox}
							label='Manutenção'
							cols='6 3 2 2'
							readOnly={readOnly} />

						<Field
							name='permissao_combustivel'
							component={LabelAndCheckbox}
							label='Combustível'
							cols='6 3 2 2'
							readOnly={readOnly} />

						<Field
							name='permissao_pneu'
							component={LabelAndCheckbox}
							label='Pneus'
							cols='6 3 2 2'
							readOnly={readOnly} />

						<Field
							name='permissao_servico'
							component={LabelAndCheckbox}
							label='Serviços'
							cols='6 3 2 2'
							readOnly={readOnly} />
					</Row>

					<BoxButtonFooter>
						{this.props.excluir ? (
							<Button
								text='Excluir'
								submit type={'danger'}
								icon={'fa fa-trash'} />
						) : (
							<Button
								text='Salvar'
								submit
								type={'success'}
								icon={'fa fa-check'} />
						)}
						<Button
							text='Cancelar'
							type={'warning'}
							icon={'fa fa-chevron-left'}
							event={() => this.props.setModoTela('lista')} />
					</BoxButtonFooter>
				</Form>
			</ContentCard>
        )
    }


}

UsuarioTipoForm = reduxForm({form: 'usuarioTipoForm', destroyOnUnmount: false})(UsuarioTipoForm);
const mapStateToProps = state => ({
	registro: state.usuarioTipo.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioTipoForm);
